import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './CategoryGrid.less';
import { CategoryGridBulb } from './CategoryGridBulb';
import { flatCategories, mapTreeChildrenToContentCategories } from '../utils/categoryTree';
import CategoryGridHeader from './CategoryGridHeader';

const CategoryGridList = ({ categories }) => {
  if (!categories || categories.length === 0) return null;

  return (
    <div className="category-grid__row">
      {categories.map(({ key: id, name: label, image_url: imgSrc, category_url: url }) => (
        <CategoryGridBulb key={id} id={id} label={label} imgSrc={imgSrc} url={url} />
      ))}
    </div>
  );
};

CategoryGridList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      children: PropTypes.arrayOf({}),
      images: PropTypes.shape({}),
      key: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};

const CategoryGrid = ({
  categoryKey,
  categoryTree,
  description,
  rootCategory,
  redesign = false,
}) => {
  if (!categoryTree) return null;

  const flattedCategories = flatCategories(categoryTree);
  const featuredCategory = flattedCategories.find(({ key }) => key === categoryKey);
  const featuredCategories = (featuredCategory?.children || []).map(
    mapTreeChildrenToContentCategories
  );
  const isBottomLevel = !featuredCategory?.children || featuredCategory?.children.length === 0;

  return (
    <div className={cx('category-grid', { isBottomLevel, redesign })}>
      <div className="wrapper-content">
        <CategoryGridHeader
          categoryKey={categoryKey}
          flattedCategories={flattedCategories}
          description={description}
          rootCategory={rootCategory}
        />
        <CategoryGridList categories={featuredCategories} />
      </div>
    </div>
  );
};

CategoryGrid.propTypes = {
  redesign: PropTypes.bool,
  categoryKey: PropTypes.string,
  description: PropTypes.string,
  categoryTree: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      children: PropTypes.arrayOf(PropTypes.shape({})),
      images: PropTypes.shape({}),
      key: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  rootCategory: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
};

export default CategoryGrid;
